import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import AccountsPreferenceConstants from '../constants/AccountsPreferenceConstants';
import RenameAccountApiUtils from '../utils/RenameAccountApiUtils';

let _backPageReference = '';
let _selectedAccount = null;
let _response = '';
let _serviceFail = false;

class RenameAccountsStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  getBackPageReference() {
    return _backPageReference;
  }

  getSelectedAccount() {
    return _selectedAccount;
  }

  getResponse() {
    return _response;
  }

  isServiceFail() {
    return _serviceFail;
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;
    switch (actionType) {
      case AccountsPreferenceConstants.RENAME_BACKPAGE_REFERENCE:
        _backPageReference = actionData.urlString;
        break;
      case AccountsPreferenceConstants.UPDATE_SELECTED_ACCOUNT_ID:
        _selectedAccount = actionData.id;
        break;
      case AccountsPreferenceConstants.UPDATE_ACCOUNT_NAME:
        RenameAccountApiUtils.updateAccountName(Object.assign({}, actionData));
        break;
      case AccountsPreferenceConstants.UPDATE_ACCOUNT_NAME_SUCCESS:
        _response = actionData;
        _serviceFail = false;
        this.emitChange();
        break;
      case AccountsPreferenceConstants.UPDATE_ACCOUNT_NAME_FAIL:
        _response = actionData.error.message;
        _serviceFail = true;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new RenameAccountsStore();
